<div>
    <h1>TEST</h1>
    <b>TIME</b>
    <i class="fa fa-phone"></i> {{timenow}}
</div>
